<app-spacer *ngIf="addTopSpacer" [spacerSize]="10"></app-spacer>

<div class="badge" [ngClass]="{'badge--ad-free': showStreamzPromoBadge}"
     [appBadgeDynamicClasses]="{'rendition': rendition, 'position':position}">
  {{ badgeCopy | translate }}
</div>
